export const scopeUri = `https://${import.meta.env.VITE_MSAL_AUTH_TENANT}.${import.meta.env.VITE_MSAL_AUTH_TENANT_DOMAIN}/${import.meta.env.VITE_MSAL_AUTH_SCOPE_ID}/api`;
